import styled from "@emotion/styled";
import { Box, Paper, alpha } from "@mui/material";

export const MesasComponentContainer = styled(Box)`
  height: 87vh;
  padding: 1rem;
  width: 100%;
  min-height: 0;
  border-radius: 30px 0px 0px 0px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  @media(max-width: 768px) {
    height: 100%;
  }
`;

type EstadoMesa = "livre" | "ocupada" | "selecionada";

interface MesaCardProps {
  estado: EstadoMesa;
}

/**
 * Ladrilho de mesa.
 *
 * Antes era um quadrado chapado de verde ou vermelho com o número dentro: dava
 * para saber se a mesa estava ocupada, e nada mais. O gerente que olha o salão
 * quer saber há quanto tempo a mesa está aberta e quanto já consumiu — por isso
 * o ladrilho virou um card claro, com a cor só na borda e no ponto de status, e
 * o espaço interno livre para a informação.
 *
 * As cores saem inteiras de `theme.palette` (a plataforma é white-label): livre
 * usa `success`, ocupada usa `primary` — a cor da marca do cliente — e a mesa
 * selecionada usa `secondary`.
 */
export const MesaCard = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "estado",
})<MesaCardProps>`
  position: relative;
  width: 100%;
  min-height: 92px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 12px;
  transition: border-color 0.2s ease, background-color 0.2s ease, transform 0.2s ease;

  ${({ estado, theme }) => {
    const cor =
      estado === "selecionada"
        ? theme.palette.secondary.main
        : estado === "ocupada"
          ? theme.palette.primary.main
          : theme.palette.success.main;

    // Mesa livre fica com borda tracejada e fundo transparente: num salão cheio
    // o que precisa saltar é o que está ocupado, não o que está vazio.
    return `
      border: ${estado === "livre" ? `1px dashed ${theme.palette.divider}` : `1px solid ${alpha(cor, 0.45)}`};
      background-color: ${estado === "livre" ? "transparent" : alpha(cor, 0.08)};
      color: ${theme.palette.text.primary};

      &:hover {
        transform: translateY(-2px);
        border-color: ${alpha(cor, 0.85)};
      }
    `;
  }}
`;

export const LegendaContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;
